import { css } from "@emotion/core";
import { color, fontTypes } from "../../constants/commons";

export const radioButtonStyle = css`
  .radio-button-override {
    background: ${color.white};
    border: 1px solid ${color.gray};
    font-family: ${fontTypes.bodyFont};
    margin: 0.5em;
    border-radius: 1.125em;
  }
  .ant-radio-button-wrapper:hover {
    color: ${color.black};
    border-color: ${color.black};
  }

  .ant-radio-group-solid
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    border-color: ${color.black};
  }
  .ant-radio-button-wrapper:not(:first-of-type)::before {
    display: none;
  }
  .ant-radio-group-solid
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    color: ${color.white};
    background: ${color.maroonishGray};
    border-radius: 1.125em;
  }
`;
